import { createApp, defineAsyncComponent } from 'vue';
import { createPinia } from 'pinia'

const app = createApp();
const pinia = createPinia();

app.use(pinia);

app.config.compilerOptions.nativeTemplate = false;
app.config.compilerOptions.whitespace = 'preserve';

// Define asynchronous components
const asyncComponents = {
    SiteHeader: defineAsyncComponent(() => import(/* webpackPrefetch: true, webpackChunkName: 'SiteHeader' */ './components/SiteHeader.vue')),
    BlogList: defineAsyncComponent(() => import(/* webpackChunkName: 'BlogList' */ './components/BlogList.vue')),
    AccordionItem: defineAsyncComponent(() => import(/* webpackChunkName: 'AccordionItem' */ './components/AccordionItem.vue')),
    TypeWriter: defineAsyncComponent(() => import(/* webpackChunkName: 'TypeWriter' */ './components/TypeWriter.vue')),
    ProgressBar: defineAsyncComponent(() => import(/* webpackChunkName: 'ProgressBar' */ './components/ProgressBar.vue')),
    DynamicModalButton: defineAsyncComponent(() => import(/* webpackChunkName: 'DynamicModalButton' */ './components/DynamicModalButton.vue')),
    SearchResults: defineAsyncComponent(() => import(/* webpackChunkName: 'SearchResults' */ './components/SearchResults.vue')),
    TruncatedText: defineAsyncComponent(() => import(/* webpackChunkName: 'TruncatedText' */ './components/TruncatedText.vue')),
    TruncatedBlock: defineAsyncComponent(() => import(/* webpackChunkName: 'TruncatedBlock' */ './components/TruncatedBlock.vue')),
    HeroCarousel: defineAsyncComponent(() => import(/* webpackChunkName: 'HeroCarousel' */ './components/HeroCarousel.vue')),
    ModalButton: defineAsyncComponent(() => import(/* webpackChunkName: 'ModalButton' */ './components/ModalButton.vue')),
    TabsWrapper: defineAsyncComponent(() => import(/* webpackChunkName: 'TabsWrapper' */ './components/TabsWrapper.vue')),
    Tab: defineAsyncComponent(() => import(/* webpackChunkName: 'Tab' */ './components/Tab.vue')),
    ImageComparisonSlider: defineAsyncComponent(() => import(/* webpackChunkName: 'ImageComparisonSlider' */ './components/ImageComparisonSlider.vue')),
    NumberCounter: defineAsyncComponent(() => import(/* webpackChunkName: 'NumberCounter' */ './components/NumberCounter.vue')),
    SearchModalButton: defineAsyncComponent(() => import(/* webpackChunkName: 'SearchModalButton' */ './components/SearchModalButton.vue')),
    LottieAnimation: defineAsyncComponent(() => import(/* webpackChunkName: 'LottieAnimation' */ './components/LottieAnimation.vue')),
    ProductGallery: defineAsyncComponent(() => import(/* webpackChunkName: 'ProductGallery' */ './components/ProductGallery.vue')),
    FadeCarousel: defineAsyncComponent(() => import(/* webpackChunkName: 'FadeCarousel' */ './components/FadeCarousel.vue')),
    ProductCardCarousel: defineAsyncComponent(() => import(/* webpackChunkName: 'ProductCardCarousel' */ './components/ProductCardCarousel.vue')),
    SocialShare: defineAsyncComponent(() => import(/* webpackChunkName: 'SocialShare' */ './components/SocialShare.vue')),
    DonationList: defineAsyncComponent(() => import(/* webpackChunkName: 'DonationList' */ './components/DonationList.vue')),
    AddressFinder: defineAsyncComponent(() => import(/* webpackChunkName: 'AddressFinder' */ './components/AddressFinder.vue')),
    FundList: defineAsyncComponent(() => import(/* webpackChunkName: 'FundList' */ './components/FundList.vue')),
};

// Register components asynchronously
for (const [componentName, asyncComponent] of Object.entries(asyncComponents)) {
    app.component(componentName, asyncComponent);
}

app.mount('#app');